import { Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core"
import { AbstractControl, ControlValueAccessor, UntypedFormGroup, FormGroupDirective, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from "@angular/forms"
import { Subscription } from "rxjs"

@Component({
    selector: "ag-input-currency",
    templateUrl: "./ag-input-currency.component.html",
    styleUrls: ["./ag-input-currency.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AgInputCurrencyComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AgInputCurrencyComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class AgInputCurrencyComponent implements ControlValueAccessor, OnDestroy, Validator, OnInit {
  @Input() formGroupName!: string
  @Input() unitOptions: string[] = []
  @Input() label!: string

  @Input() hint?: string
  showHint: boolean = false

  @ViewChild("viewControl") viewControl?: ElementRef

  public formGroup!: UntypedFormGroup
  subscriptions: Subscription[] = []

  constructor(private rootFormGroup: FormGroupDirective, private renderer: Renderer2) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe())
  }

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(this.formGroupName) as UntypedFormGroup
    this.subscriptions.push(
      this.formGroup.valueChanges.subscribe((value) => {
        this.onChange(value)
        this.onTouched()
        this.showHint = false
      })
    )

    if (this.unitOptions.length === 0 && this.formGroup.controls["unit"]?.value !== null) {
      this.unitOptions.push(this.formGroup.controls["unit"].value)
      this.formGroup.controls["unit"].disable()
    }
  }

  writeValue(value: any): void {
    this.formGroup.setValue(value)
  }

  onChange = (_: any) => {}
  onTouched = () => {}
  registerOnChange = (fn: any): void => (this.onChange = fn)
  registerOnTouched = (fn: any): void => (this.onTouched = fn)

  validate(control: AbstractControl): ValidationErrors | null {
    const unitErrors = this.formGroup.get("unit")?.errors
    const valueErrors = this.formGroup.get("value")?.errors
    return unitErrors || valueErrors
      ? {
          unit: unitErrors,
          value: valueErrors,
        }
      : null
  }

  onFocus = () => this.renderer.addClass(this.viewControl?.nativeElement, "focussed")
  onBlur = () => this.renderer.removeClass(this.viewControl?.nativeElement, "focussed")
}
